import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgTwoStepVerificationLearnMoreModal',
})
export default class CmgTwoStepVerificationLearnMoreModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.twoStepVerificationLearnMoreModal.visible;
  }

  get legalCopy(): string {
    return this.$services.config.getLegalText().createAnAccount2sv;
  }

  onClickOk() {
    this.onClose();
  }

  onClose() {
    this.$services.ui.setModalVisibility('twoStepVerificationLearnMoreModal', false);
    this.$services.ui.focusBack();
  }
}
